export enum AlertStatus {
  OPEN,
  ACKNOWLEDGED,
  CLOSED,
}
